import React from "react";
import { routerType } from "../utils/types/props.route";

import Home from "../pages/main/Home/";
import Packages from "../pages/main/packages/";
import Indicators from "../pages/main/indicators/";

import QualityControl from "../pages/main/qualityControl/";
import Qualityimprovement from "../pages/main/QI/";
import QIProject from "../pages/main/QI/QiProject/";
import ChartDashboard from "../pages/main/QI/charts/chartDashboard/";
import NewProject from "../pages/main/QI/QiProject/newproject/";
import Login from "../pages/auth/login/";
import ExsistingProject from "../pages/main/QI/QiProject/exsistingproject/";
import QCIndicators from "../pages/main/qualityControl/indicators/";
import DataEntry from "../pages/main/DataEntry";
import ViewData from "../pages/main/DataEntry/ViewData";
import SignUp from "../pages/auth/signup";
import UserManagement from "../pages/main/UserManagment";
import UserProfile from "../pages/main/UserProfile";
import EditProject from "../pages/main/QI/QiProject/editProject";
import RoleManagement from "../pages/main/RoleManagement";

const PagesData: routerType[] = [
  {
    path: "/login",
    element: <Login />,
    title: "Login",
    requiresAuth: false,
  },
  {
    path: "/signup",
    element: <SignUp />,
    title: "SignUp",
    requiresAuth: false,
  },
  {
    path: "/user-management",
    element: <UserManagement />,
    title: "UserManagement",
    requiresAuth: true,
  },
  {
    path: "/role-management",
    element: <RoleManagement />,
    title: "UserManagement",
    requiresAuth: true,
  },
  {
    path: "/user-profile",
    element: <UserProfile />,
    title: "User Profile",
    requiresAuth: true,
  },
  {
    path: "/",
    element: <Home />,
    title: "Home",
    requiresAuth: true,
  },
  {
    path: "/indicator-packages",
    element: <Packages />,
    title: "Package",
    requiresAuth: true,
  },
  {
    path: "/indicator-packages/:name/:id",
    element: <Indicators />,
    title: "Indicator",
    requiresAuth: true,
  },
  {
    path: "/quality-control",
    element: <QualityControl />,
    title: "Quality Control",
    requiresAuth: true,
  },
  {
    path: "/data-entry",
    element: <DataEntry />,
    title: "Data Entry",
    requiresAuth: true,
  },
  {
    path: "data-entry/data/:project",
    element: <ViewData />,
    title: "View Data",
    requiresAuth: true,
  },
  {
    path: "quality-control/indicator-packages/:name/:id",
    element: <QCIndicators />,
    title: "Indicator",
    requiresAuth: true,
  },
  {
    path: "/quality-improvement",
    element: <Qualityimprovement />,
    title: "Quality improvement",
    requiresAuth: true,
  },
  {
    path: "/quality-improvement/qi-project",
    element: <QIProject />,
    title: "QI Project",
    requiresAuth: true,
  },
  {
    path: "/quality-improvement/create-project",
    element: <NewProject />,
    title: "QI Project",
    requiresAuth: true,
  },
  {
    path: "/quality-improvement/qi-project/existing-projects",
    element: <ExsistingProject />,
    title: "Existing Projects",
    requiresAuth: true,
  },
  {
    path: "/quality-improvement/qi-project/edit-project//:projectId",
    element: <EditProject />,
    title: "Edit Project",
    requiresAuth: true,
  },
  {
    path: "/quality-improvement/charts",
    element: <ChartDashboard />,
    title: "Charts",
    requiresAuth: true,
  },
];

export default PagesData;
